import React, { Children, useState } from 'react';
import classes from './AddEditServiceItem.module.css';
import CommonCard from '../CommonCard';
import Checkbox from '../../UI/Checkbox';
import { numberFormatter } from '../../../Helpers';
import SimpleCheckbox from '../../UI/SimpleCheckbox';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import {
  addQuantityInSelectedServiceList,
  decrementQuantityInSelectedServiceList,
  zeroQuantityInSelectedServiceList
} from '../../../Store/serviceSlice';
const findSelectedEle = (array, obj) => {
  return array?.find((ele) => ele?.serviceId == obj?.id);
};
const AddEditServiceItem = ({ data, arr, setArr, checkbox = true, children }) => {
  let transformData = { id: data?.serviceId, ...data };
  const selectedServices = useSelector((state) => state?.serviceReducer?.selectedServices);
  
  const dispatch = useDispatch();
  return (
    <CommonCard className={classes.mainWrapper}>
      {checkbox && (
        <SimpleCheckbox
          id={'service-item-checkbox'}
          className={clsx(classes.checkbox, {
            [classes.checked]: data?.quantity > 1
          })}
          data={data}
          checked={findSelectedEle(selectedServices, transformData)?.quantity > 0}
          defaultChecked={data?.quantity > 0}
          setter={(e) => {
            if (e?.target?.checked) {
              dispatch(addQuantityInSelectedServiceList(data));
            } else {
              dispatch(zeroQuantityInSelectedServiceList(data?.serviceId));
            }
          }}
          label={transformData}
          showLabel={false}
        />
      )}
      <div className={classes.dataWrapper}>
        <p className={classes.name}>{data.serviceName}</p>
        <p className={classes.fee}>{`Rs. ${numberFormatter(data.serviceFees)}`}</p>
      </div>
      {children}
    </CommonCard>
  );
};

export default AddEditServiceItem;
